"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonClear = exports.ButtonFlat = exports.ButtonSecondary = exports.ButtonPrimary = exports.commonButtonProps = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../themes/colors");
exports.commonButtonProps = (0, styled_components_1.css) `
  ${({ theme, small, fullWidth, disabled }) => (0, styled_components_1.css) `
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    -webkit-tap-highlight-color: transparent;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: none;
    outline: none;
    box-sizing: border-box;
    padding: 0 ${theme.spacing.unit * 3}px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: ${theme.spacing.unit * 6}px;
    border-radius: 40px;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 14px;
    text-align: center;
    font-family: 'Saeada', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
      Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
    width: ${fullWidth ? '100%' : 'fit-content'};
    ${small &&
    (0, styled_components_1.css) `
      font-size: 14px;
      padding: 0 ${theme.spacing.unit}px;
      height: 36px;
    `}
    ${disabled &&
    (0, styled_components_1.css) `
      &:disabled {
        background: ${colors_1.colors.shade30};
        color: ${colors_1.colors.shade50};
        cursor: default;
      }
    `}
  `}
`;
exports.ButtonPrimary = styled_components_1.default.button `
  ${exports.commonButtonProps}
  ${({ disabled }) => (0, styled_components_1.css) `
    color: ${colors_1.colors.white};
    background: ${colors_1.colors.gradientPrimary};

    ${!disabled &&
    (0, styled_components_1.css) `
      &:hover {
        background: ${colors_1.colors.gradientPrimaryHover};
      }
      &:active {
        background: ${colors_1.colors.gradientPrimaryActive};
      }
    `}
  `}
`;
exports.ButtonSecondary = styled_components_1.default.button `
  ${exports.commonButtonProps}
  ${({ disabled }) => (0, styled_components_1.css) `
    color: ${colors_1.colors.white};
    background: ${colors_1.colors.verseNavBlue};
    box-shadow: 0px 1px 1px 0px #ffffff26 inset;

    ${!disabled &&
    (0, styled_components_1.css) `
      &:hover {
        background: ${colors_1.colors.gradientSecondaryHover};
      }
      &:active {
        background: ${colors_1.colors.gradientSecondaryActive};
      }
    `}
  `}
`;
exports.ButtonFlat = styled_components_1.default.button `
  ${exports.commonButtonProps}
  ${({ disabled }) => (0, styled_components_1.css) `
    color: ${colors_1.colors.white};
    background: transparent;
    border: 1px solid ${colors_1.colors.shade50};

    ${!disabled &&
    (0, styled_components_1.css) `
      &:hover {
        background: ${colors_1.colors.gradientSecondaryHover};
      }
      &:active {
        background: ${colors_1.colors.gradientSecondaryActive};
      }
    `}
  `}
`;
exports.ButtonClear = styled_components_1.default.button `
  ${exports.commonButtonProps}
  ${({ disabled }) => (0, styled_components_1.css) `
    color: ${colors_1.colors.verseBlue};
    background: transparent;
    font-size: 14px;
    font-weight: 600;
    text-align: center;

    ${disabled &&
    (0, styled_components_1.css) `
      &:disabled {
        background: transparent;
        color: ${colors_1.colors.shade40};
        cursor: default;
      }
    `}

    ${!disabled &&
    (0, styled_components_1.css) `
      &:hover {
        color: ${colors_1.colors.white};
      }

      &:active, :focus-within {
        color: ${colors_1.colors.shade80}};
      }
    `}
  `}
`;
//# sourceMappingURL=styled.js.map